function initQuestaoRoot(root: HTMLElement): void {
	if (root.dataset.msjQuestaoBound === '1') {
		return;
	}
	root.dataset.msjQuestaoBound = '1';

	const correct = parseInt(root.getAttribute('data-correct-index') ?? '-1', 10);
	const options = root.querySelectorAll<HTMLButtonElement>('[data-msj-questao-option]');
	const feedbackOk = root.querySelector<HTMLElement>('[data-msj-questao-feedback-ok]');
	const feedbackErr = root.querySelector<HTMLElement>('[data-msj-questao-feedback-err]');
	const cta = root.querySelector<HTMLElement>('[data-msj-questao-cta]');

	const base =
		'msj-questao-option w-full rounded-lg border p-4 mb-3 text-left text-base transition-colors duration-150';
	const neutral =
		'border-slate-200 bg-white text-inherit cursor-default disabled:opacity-100 disabled:text-inherit';
	const chosenCorrect =
		'border-emerald-600 bg-emerald-50 text-emerald-800 ring-1 ring-emerald-600 cursor-default disabled:opacity-100';
	const chosenWrong =
		'border-red-600 bg-red-50 text-red-700 ring-1 ring-red-500 cursor-default disabled:opacity-100';

	options.forEach((btn) => {
		btn.addEventListener('click', () => {
			if (root.dataset.answered === '1') {
				return;
			}
			root.dataset.answered = '1';

			const picked = parseInt(btn.getAttribute('data-index') ?? '-1', 10);
			const isCorrect = picked === correct;

			options.forEach((b) => {
				const idx = parseInt(b.getAttribute('data-index') ?? '-1', 10);
				b.disabled = true;
				b.setAttribute('aria-pressed', idx === picked ? 'true' : 'false');

				if (isCorrect) {
					b.className = base + ' ' + (idx === picked ? chosenCorrect : neutral);
				} else {
					b.className = base + ' ' + (idx === picked ? chosenWrong : neutral);
				}
			});

			if (isCorrect) {
				feedbackOk?.classList.remove('hidden');
			} else {
				feedbackErr?.classList.remove('hidden');
			}

			if (cta) {
				cta.classList.remove('bg-zinc-700', 'hover:bg-zinc-800');
				cta.classList.add('bg-red-600', 'hover:bg-red-700', 'shadow-md');
			}
		});
	});
}

export function initQuestaoBlocks(): void {
	document.querySelectorAll<HTMLElement>('[data-msj-questao]').forEach(initQuestaoRoot);
}
